import PropTypes from 'prop-types';
import Figure from '../../../Figure/Figure';

// Import des images et schémas popins politique
import politique_ondes from '../../../../assets/img/results/pastilles/politique/POLITIQUE_01_Pastille_Boutons_des_ondes_75.webp';
import politique_cadran from '../../../../assets/img/results/pastilles/politique/POLITIQUE_02_Pastille_Cadran_des_frequences_75.webp';
import schema_politique_ondes_longues from '../../../../assets/img/results/pastilles/politique/schemas--ondes_longues.webp';
import schema_politique_ondes_courtes from '../../../../assets/img/results/pastilles/politique/schemas--ondes_courtes.webp';
import politique_eraflure_roosvelt from '../../../../assets/img/results/pastilles/politique/POLITIQUE_03_Pastille_Eraflure_Roosevelt_75.webp';

// Import des images et schémas popins intime
import intime_tuner from '../../../../assets/img/results/pastilles/intime/INTIME_01_Pastille_Tuner_75.webp';
import intime_volume from '../../../../assets/img/results/pastilles/intime/INTIME_02_Pastille_Volume_75.webp';
import intime_tache from '../../../../assets/img/results/pastilles/intime/INTIME_03_Tache_LovinFun_RESIZED_75.webp';
import schema_intime_tuner from '../../../../assets/img/results/pastilles/intime/schemas--tuner.webp';
import intime_volume_plage from '../../../../assets/img/results/pastilles/intime/INTIME_04_Volume_Plage_75.webp';

// Import des images et schémas popins festive
import festive_anse from '../../../../assets/img/results/pastilles/festive/FESTIVE_01_Pastille_Anse_de_Transport_75.webp';
import festive_haut_parleur from '../../../../assets/img/results/pastilles/festive/FESTIVE_02_Pastile_Haut_Parleur_75.webp';
import festive_revetement from '../../../../assets/img/results/pastilles/festive/FESTIVE_03_Pastille_Revetement_75.webp';
import festive_radio1_revetement from '../../../../assets/img/results/pastilles/festive/Festive_03_Revetement_Jambon_RESIZED_75.webp';
import festive_radio2_revetement from '../../../../assets/img/results/pastilles/festive/thumbnail_Sonora-Excellence-301-a-1_RESIZED_75.webp';
import schema_festive_haut_parleur from '../../../../assets/img/results/pastilles/festive/schemas--haut_parleur.webp';

function PopinContent({ vid, handleClosePopin, buttonRef, handleKeyDownFunc }) {
  return (
    <>
        {vid === 1 && <ContentViewTuner />}
        {vid === 2 && <ContentViewVolume />}
        {vid === 3 && <ContentViewTache />}
        {vid === 4 && <ContentViewChoixDesOndes />}
        {vid === 5 && <ContentViewCadranFrequence />}
        {vid === 6 && <ContentViewEraflure />}
        {vid === 7 && <ContentViewLanniereTransport />}
        {vid === 8 && <ContentViewHautParleur />}
        {vid === 9 && <ContentViewRevetement />}
        <div><button className="button button--dark" onClick={handleClosePopin} ref={buttonRef} onKeyDown={handleKeyDownFunc}>retour à ma radio</button></div>
    </>
  )
}

PopinContent.propTypes = {
  vid: PropTypes.number.isRequired,
  handleClosePopin: PropTypes.func.isRequired,
  buttonRef: PropTypes.object.isRequired,
  handleKeyDownFunc: PropTypes.func.isRequired
}

export default PopinContent;

// Création des fonctions qui vont gérer l'affichage spécifique en fonction du point d'intéret
// affiché dans la popin
function ContentViewTuner() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': intime_tuner, 'mobile': intime_tuner}}
                    hasCreditsPopin={true}
                    credits={<><p>Le tuner de la Radio Microcapte.</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Ce bouton vous permet de choisir une fréquence. Mais changer,
                    pour vous, c’est hors de question. Vous êtes fidèle à une station.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur le tuner</h2>
                <p>
                    Le son est une vibration de l’air, une onde acoustique, qui doit être
                    convertie en onde radio pour être transportée sur de grandes distances
                    et diffusée à tous les auditeurs. Ce signal radio est envoyé sur
                    plusieurs bandes de fréquences via les antennes d’émission.
                </p>
                <p>
                    Tourner le tuner permet de sélectionner une partie du signal en
                    filtrant l’une des fréquences captées par l’antenne de votre récepteur
                    radio. Les parties du signal qui ne sont pas de cette fréquence
                    sont rejetées pour ne conserver que la bande sélectionnée, par
                    exemple celle qui correspond à votre station préférée.
                </p>
                <p>
                    Aujourd’hui les tuners permettent de mémoriser certains canaux.
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--13 mobile-col-start--1 mobile-col-end--7 quiz-figure--2"
                    medias={{'desktop': schema_intime_tuner, 'mobile': schema_intime_tuner}}
                    hasCreditsPopin={false}
                    hasCaption={false}
                    mediaAlt="Deux graphiques : le premier montre la tension (en volts) en fonction de la fréquence des signaux radio, avec plusieurs pics ; le second illustre le filtrage d’une fréquence spécifique, mettant en évidence la sélection d’un signal ciblé." />
            </div>
        </>
    )
}

function ContentViewVolume() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': intime_volume, 'mobile': intime_volume}}
                    hasCreditsPopin={true}
                    credits={<><p>Le bouton de volume de la Radio Microcapte.</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Généralement, vous réglez le son tout bas, pour ne pas être dérangé.e,
                    quand vous vous perdez dans vos pensées.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur le volume</h2>
                <p>
                    Le radio transistor, une radio mobile et légère qui fonctionne sur piles,
                    apparaît en France à la fin des années 1950. Rapidement appelé «&nbsp;transistor&nbsp;»
                    tout court, il change les usages des Français. Il est transportable
                    partout à tout moment et s’écoute seul ou à plusieurs.
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': intime_volume_plage, 'mobile': intime_volume_plage}}
                    hasCreditsPopin={true}
                    credits={<><p>La radio est partout... 1982.</p><p>&copy; Barbara Alper/Getty Images</p></>}
                    hasCaption={false} />
                <p>
                    En mars 1960, les pouvoirs publics prennent des mesures pour éviter
                    la cacophonie dans l’espace public. Le radio transistor est d’abord
                    interdit dans les gares. Puis, il est prohibé dans le métro parisien
                    et dans l’espace public de nombreuses communes. Les automobilistes
                    sont également priés de faire attention au volume sonore de leur
                    autoradio pour ne pas déranger les voisins.
                </p>
            </div>
        </>
    )
}

function ContentViewTache() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <p>
                    Vous avez renversé un bon thé bien chaud. À moins que ça ne soit vos larmes 😥
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur la tache</h2>
                <p>
                    Dès les débuts de la radio, des émissions sont dédiées au courrier des auditeurs.
                    Leurs questions ou leurs confessions prennent de l’espace sur les ondes. En après-midi,
                    sur RTL, entre les années 60 et les années 80, Menie Grégoire répond aux appels en
                    direct et contribue à vulgariser la psychanalyse.
                </p>
                <p>
                    Dans l’émission <em>Allô Macha</em> sur France Inter, des années 70 au début des années 2000,
                    les auditeurs s’appellent les «&nsp;sans-sommeil&nbsp;». Ils se confient à l’animatrice Macha
                    Béranger tard le soir pour déjouer l’ennui ou la solitude.
                </p>
                <p>
                    Dans les années 90, certaines émissions s’adressent aux ados en particulier.
                    Dans <em>Lovin’ Fun</em>, Difool est accompagné d’un pédiatre, Christian Spitz,
                    dit le Doc, pour leur parler de sexualité et de sujets de société.
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': intime_tache, 'mobile': intime_tache}}
                    hasCreditsPopin={true}
                    credits={<><p>Doc & Difool, animateurs de Radio Fun.</p><p>&copy; Eric Robert/Sygma/Sygma via Getty Images</p></>}
                    hasCaption={false} />
            </div>
        </>
    )
}

function ContentViewChoixDesOndes() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': politique_ondes, 'mobile': politique_ondes}}
                    hasCreditsPopin={true}
                    credits={<><p>Boutons de choix des ondes. Détail.</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Ces boutons vous permettent de changer le type d’ondes : grandes (nationales),
                    petites (régionales) ou courtes (internationales). Et c’est vrai que, parfois,
                    il vous prend l’envie d’écouter des débats en finnois.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur le choix des ondes</h2>
                <p>
                    Différents types d’ondes électromagnétiques sont captées par les radios.
                    Elles ont chacune des avantages et des inconvénients.
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--10 mobile-col-start--2 mobile-col-end--6 quiz-figure--2 quiz-figure--schema"
                    mediaContainerClassName="desktop-col-start--1 desktop-col-end--4 mobile-col-start--1 mobile-col-end--5"
                    medias={{'desktop': schema_politique_ondes_courtes, 'mobile': schema_politique_ondes_courtes}}
                    hasCreditsPopin={false}
                    hasCaption={true}
                    caption={[
                        (<span key="c1">Schéma simplifié de la diffusion des ondes courtes.</span>),
                        (<ol key="c2">
                            <li><span>émetteur</span></li>
                            <li><span>ondes courtes</span></li>
                            <li><span>ionosphère</span></li>
                            <li><span>sol</span></li>
                            <li><span>récepteur</span></li>
                        </ol>)
                    ]}
                    mediaAlt="image légendée" />
                <p>
                    Les ondes courtes (OC) sont surtout utilisées pour la radio internationale
                    ou intercontinentale. Contrairement à ce que leur nom indique, elles parcourent
                    de très longues distances en rebondissent sur l&apos;ionosphère (haute atmosphère de la Terre).
                </p>
                <p>
                    Le son transporté par les ondes courtes n’est pas d’une grande précision
                    et sa qualité dépend des conditions atmosphériques.
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--10 mobile-col-start--2 mobile-col-end--6 quiz-figure--2 quiz-figure--schema"
                    mediaContainerClassName="desktop-col-start--1 desktop-col-end--4 mobile-col-start--1 mobile-col-end--5"
                    medias={{'desktop': schema_politique_ondes_longues, 'mobile': schema_politique_ondes_longues}}
                    hasCreditsPopin={false}
                    hasCaption={true}
                    caption={[
                        (<span key="c1">Schéma simplifié de la diffusion des ondes petites, moyennes et grandes.</span>),
                        (<ol key="c2">
                            <li><span>émetteur</span></li>
                            <li><span>ondes petites, moyennes et grandes</span></li>
                            <li><span>récepteur</span></li>
                            <li><span>sol</span></li>
                        </ol>)
                    ]}
                    mediaAlt="image légendée" />
                <p>
                    Les grandes ondes (GO) parcourent environ 1000 km par le sol.
                    Elles ont été adaptées à la diffusion des chaînes nationales et
                    périphériques en France hexagonale mais nécessitaient de très
                    grands pylônes portant les antennes. Elles ont été progressivement
                    remplacées à l’arrivée de la bande FM.
                </p>
                <p>
                    Petites et moyennes ondes (PO) sont diffusées par le sol sur plusieurs
                    centaines de km, ce qui leur permet d’être plus précises mais sur de petites
                    distances pour les radios régionales.
                </p>
            </div>
        </>
    )
}

function ContentViewCadranFrequence() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': politique_cadran, 'mobile': politique_cadran}}
                    hasCreditsPopin={true}
                    credits={<><p>Détail du cadran des fréquences.</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Ce cadran affiche les fréquences de vos stations préférées, vous savez,
                    celles qui diffusent les débats où les intervenants finissent par s’injurier.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur le cadran de fréquences</h2>
                <p>
                    La radio est un monopole d’État jusqu’en 1982. Des radios connues
                    aujourd’hui étaient dites « périphériques » parce qu&apos;elles
                    émettaient depuis l’étranger. Ces radios sont visibles sur le cadran des
                    fréquences en grandes ondes (GO).
                </p>
                <p>
                    Europe n°1 émettait depuis la Sarre en Allemagne. Cette radio
                    qui naît dans les années 1950 touche un public de lycéens et d’étudiants,
                    avec des émissions emblématiques comme <em>Salut les copains</em> et <em>Campus</em>, mais
                    également des cadres, avec des programmes d’informations. Comme RTL,
                    elle est l’une des rares radios à couvrir les événements de mai 1968.
                </p>
                <p>
                    Radio Luxembourg (devenue RTL) est lancée dès les années 1930. Dans un
                    premier temps, elle est captée uniquement dans le nord de la France. À
                    partir des années 1960, elle s’écoute partout sur le territoire hexagonal
                    et plutôt par un public familial.
                </p>
                <p>
                    Radio Monte Carlo (ou RMC), est implantée dans la Principauté de Monaco
                    et copropriété pendant plusieurs décennies de l’État français. Aujourd’hui
                    célèbre pour ses retransmissions sportives, elle programmait des jeux, du
                    divertissement et de la musique dans les années 1960 à 1990.
                </p>
            </div>
        </>
    )
}

function ContentViewEraflure() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <p>
                    Vous vous souvenez ? Vous l’avez balancé contre un mur en écoutant
                    les résultats d’une élection. Depuis, elle fait de drôles de sons.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur l&apos;éraflure</h2>
                <p>
                    La radio est utilisée aux États-Unis dès les années 1920 pour les
                    élections présidentielles. Franklin Roosevelt va s&apos;emparer du pouvoir
                    de la radiodiffusion pour ses campagnes électorales et interviendra de
                    plus en plus régulièrement sur les ondes entre 1933 et 1944, lors de
                    rendez-vous en soirée appelés les « causeries au coin du feu ». Il explique
                    sa politique du New Deal, dément les rumeurs et rassure la population pendant
                    la Grande Dépression puis la Seconde Guerre mondiale.
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': politique_eraflure_roosvelt, 'mobile': politique_eraflure_roosvelt}}
                    hasCreditsPopin={true}
                    credits={<><p>Le président Franklin D. Roosevelt durant l&apos;un de ses discours «&nbsp;au coin du feu&nbsp;». Avril 1942.</p><p>&copy; <a target="_blank" href="https://www.gettyimages.fr/search/photographer?photographer=Bettmann">Bettmann</a>/Getty Images</p></>}
                    hasCaption={false} />
                <p>
                    En France, la première campagne législative radiodiffusée est celle
                    d’avril-mai 1936 qui sera remportée par le Front populaire. Tous les
                    partis peuvent s’exprimer au micro. On y entend Léon Blum et Maurice
                    Thorez. Si l’impact de la radio sur ce suffrage a été limité, c’est un jalon
                    important de son utilisation comme instrument politique et l’instauration des
                    premières règles de temps de parole pour assurer le pluralisme de ce
                    nouveau média.
                </p>
            </div>
        </>
    )
}

function ContentViewLanniereTransport() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': festive_anse, 'mobile': festive_anse}}
                    hasCreditsPopin={true}
                    credits={<><p>Transport de la radio Microcapte</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Cette lanière vous permet de trimballer votre poste partout. En pic-pic,
                    en soirée… C’est un peu votre sac à main musical, pour résumer.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur l&apos;anse de transport</h2>
                <p>
                    L’arrivée du transistor change les usages. Le composant électronique
                    permet de miniaturiser les radios et d’assurer leur fonctionnement sur piles.
                </p>
                <p>
                    Le radio transistor, qui est rapidement appelé «&nbsp;transistor&nbsp;» tout court,
                    devient symbole de mobilité : on le transporte partout pour l’écouter
                    à tout moment, seul ou à plusieurs.
                </p>
                <p>
                    Les conséquences de ce passage à la portabilité sont multiples :
                    les contenus changent et ceux qui les écoutent aussi. C’est le
                    début de la radio individuelle, des programmes spécifiques sont
                    proposés pour certaines classes d’âges. Cette période correspond à
                    l&apos;affirmation d’une nouvelle catégorie sociale : la jeunesse.
                </p>
            </div>
        </>
    )
}

function ContentViewHautParleur() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': festive_haut_parleur, 'mobile': festive_haut_parleur}}
                    hasCreditsPopin={true}
                    credits={<><p>Zoom sur le haut-parleur de la Radio Microcapte.</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Globalement, vous mettez le son à fond. Si le tympan n’est pas percé, c’est qu’on n&apos;a pas assez profité.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur le haut parleur</h2>
                <p>
                    Il en existe plusieurs types : on connait surtout le Woofer ou Boomer
                    pour les basses (les sons graves entre 20 Hz et 500 Hz) mais également
                    le Tweeter pour les aigus (fréquences supérieures à 2000 Hz). Le haut-parleur
                    à large bande, visible sur votre Microcapte, permet de restituer toute la
                    largeur du spectre audible. Les enceintes regroupent différentes sortes de
                    haut-parleurs spécialisés du grave à l’aigu en passant par le medium.
                </p>
                <p>
                    Le haut-parleur joue le rôle inverse d’un microphone. Il transforme
                    le signal électrique reçu par le récepteur radio en son. Une bobine
                    se déplace dans un aimant vers la membrane et produit des changements
                    de pression d’air. Ces vibrations peuvent être perçues par les
                    oreilles humaines (entre 20 Hz et 20 000 Hz).
                </p>
                <Figure
                    className="desktop-col-start--3 desktop-col-end--10 mobile-col-start--2 mobile-col-end--6 quiz-figure--2 quiz-figure--schema"
                    mediaContainerClassName="desktop-col-start--1 desktop-col-end--4 mobile-col-start--1 mobile-col-end--5"
                    medias={{'desktop': schema_festive_haut_parleur, 'mobile': schema_festive_haut_parleur}}
                    hasCreditsPopin={false}
                    hasCaption={true}
                    caption={[
                        (<span key="c1">Schéma simplifié d’un haut-parleur électrodynamique</span>),
                        (<ol key="c2">
                            <li><span>bobine</span></li>
                            <li><span>aimant</span></li>
                            <li><span>fils de connexion</span></li>
                            <li><span>membrane</span></li>
                            <li><span>châssis</span></li>
                        </ol>)
                    ]}
                    mediaAlt="image légendée" />
            </div>
        </>
    )
}

function ContentViewRevetement() {
    return (
        <>
            <div className="popin-result__introduction grid--container">
                <Figure
                    className="desktop-col-start--3 desktop-col-end--8 mobile-col-start--2 mobile-col-end--6 quiz-figure--1"
                    medias={{'desktop': festive_revetement, 'mobile': festive_revetement}}
                    hasCreditsPopin={true}
                    credits={<><p>Détail du revêtement de la Radio Microcapte.</p><p>&copy; Antoine Laporte</p></>}
                    hasCaption={false} />
                <p>
                    Vous avez choisi le simili croco, pour être simili stylé.e quand
                    vous l’emmenez en soirée.
                </p>
            </div>
            <div className="popin-result__content grid--container">
                <h2>Plus d&apos;infos sur le revêtement</h2>
                <p>
                    La radio est constituée de différents matériaux. À ses débuts,
                    abordable pour les sans-filistes, ces amateurs bricoleurs, elle
                    est faite de galène ou de tubes électroniques et de fonte. Elle
                    intègre aussi les intérieurs bourgeois dans un coffre en bois au
                    travail soigné que l’on appelle ébénisterie.
                </p>
                <p>
                    Par la suite, la radio est souvent en bakélite, un plastique isolant et résistant.
                    Tour à tour meuble imposant ou objet qui se glisse dans la poche, elle prend toutes
                    les formes imitant les carrosseries de voiture (Sonora Excellence 301) ou rappelant
                    une boîte à jambon (Philipps, forme cathédrale).
                </p>
                <p>
                    Les coques sont réputées incassables, lavables et sont proposées en différents coloris.
                    Votre Microcapte de Radio Célard est disponible en bordeaux (façon croco), en pied de poule
                    (gris, noir et blanc), en faux uni beige (imitation cuir), etc.
                </p>
                <div className="desktop-col-start--3 desktop-col-end--13 mobile-col-start--2 mobile-col-end--6">
                    <Figure
                        className="quiz-figure--2"
                        medias={{'desktop': festive_radio1_revetement, 'mobile': festive_radio1_revetement}}
                        hasCreditsPopin={true}
                        credits={<><p>Récepteur radio Philips dite Boite à jambon, 1931.</p><p>&copy; Perrine Le Maignan/Musée de Radio France </p></>}
                        hasCaption={false} />
                    <Figure
                        className="quiz-figure--3"
                        medias={{'desktop': festive_radio2_revetement, 'mobile': festive_radio2_revetement}}
                        hasCreditsPopin={true}
                        credits={<><p>Radio Sonora Excellence 301, 1948.</p><p>&copy; Radiomuseum.org</p></>}
                        hasCaption={false} />
                </div>
            </div>
        </>
    )
}
